import React from "react";

const IdLabel = ({id}) => <p className='italic text-gray-500 pl-2'>ID: {id}</p>

export default IdLabel
